<ol class="list-decimal ps-6">

  <li *ngFor="let item of items; let i = index" class="mb-2 wrap-anywhere">

    {{ item }}

    <button
      *ngIf="editable"
      type="button"
      (click)="removeItem(i)"
      class="section-delete-btn section-delete-btn-sm ms-2">

      {{ 'COMMON.DELETE' | translate }}

    </button>

  </li>

</ol>

<div *ngIf="editable" class="mt-3 flex flex-wrap items-center gap-2">

  <input
    [(ngModel)]="newItem"
    class="h-10 rounded-xl border border-gray-300 px-3 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
    [placeholder]="'CREDIT_SECTION.ADD_RISK' | translate">

  <button
    type="button"
    (click)="addItem()"
    class="section-add-btn">

    {{ 'COMMON.ADD' | translate }}

  </button>

</div>